import React from 'react';

const Revert = () => (
    <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="icons/revert" transform="translate(-6.000000, 0.000000)" fill="#0852E0">
                <path
                    d="M24,17.9 L25.3,19.2 L27.2,17.3 L28.6,15.9 L30,14.6 L25.3,9.9 L24,11.1 L26.6,13.5 L24.1,13.5 C24.1,13.5 24.1,13.5 24,13.5 L23.9,13.5 C22.2,13.5 20.6,14.3 19.5,15.5 C18.5,16.6 18,18 18,19.5 C18,22.8 20.7,25.5 24,25.5 C25.6,25.5 27,24.9 28,23.9 L26.6,22.5 C25.9,23.1 25,23.5 24,23.5 C21.8,23.5 20,21.7 20,19.5 C20,17.3 21.8,15.5 24,15.5 L24.1,15.5 L26.8,15.5 L26.2,16.1 L24,17.9 L24,17.9 Z"
                    id="restart--glyph"
                ></path>
            </g>
        </g>
    </svg>
);

export default Revert;
